<template>
  <div class="adminBox">
    <Form ref="searchForm" :label-width="100" :model="formCustom" inline>
      <Form-item label="用户账号：" prop="nikeName">
        <Input v-model="formCustom.nikeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="用户账号编码：" prop="adminCode">
        <Input v-model="formCustom.adminCode" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="关联角色：" prop="roleId">
        <Select v-model="formCustom.roleId" clearable filterable style="width: 200px" @on-change="changeRole">
          <Option v-for="item in roleList" :value="item.roleId">{{ item.roleName }}</Option>
        </Select>
      </Form-item>
      <Form-item label="状态：" prop="status">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px" @on-change="changeStatus">
          <Option value="1">有效</Option>
          <Option value="-1">锁定</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button v-if="btnList.includes('新增')" type="primary" @click="handleButton('add')">新增</Button>
    </div>
    <div>
      <Table :columns="adminColumns" :data="adminTableData" :loading="loading" aria-describedby="" aria-hidden="true"
             border>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="btnList.includes('编辑')" size="small" type="text" @click="handleButton('edit', row.adminId)">
            编辑
          </Button>
          <Button v-if="btnList.includes('重置密码')" size="small" type="text"
                  @click="handleButton('authority', row.adminId)">重置密码
          </Button>
          <Button v-if="btnList.includes('删除') && row.nikeName !== getAdminName" size="small" type="text"
                  @click="remove(row.adminId)">删除
          </Button>
          <Button v-if="row.status === '有效' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('lock', row.adminId)">锁定
          </Button>
          <Button v-if="row.status === '锁定' && btnList.includes('锁定')" size="small" type="text"
                  @click="lockButton('unlock', row.adminId)">解锁
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import {adminDelete, adminLock, adminPage, roleList} from '@/api/authority'
import permissionList from '@/libs/handlePermission.ts'

export default {
  name: 'admin',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      roleList: [], // 关联角色下拉框
      lockMsg: '', // 锁定/解锁
      lockStatus: '', // 锁定/解锁状态
      getAdminName: '',
      btnList: [],
      formCustom: {
        nikeName: '',
        roleId: '',
        status: '',
        adminCode: ''
      },
      adminColumns: [
        {type: 'index', title: '序号', width: 90, align: 'center'},
        {title: '创建时间', key: 'createTime', width: 160, align: 'center'},
        {title: '用户账号', key: 'nikeName', align: 'center'},
        {title: '关联角色', key: 'roleName', align: 'center'},
        {title: '用户账号编码', key: 'adminCode', width: 140, align: 'center'},
        {title: '联系电话', key: 'telephone', width: 140, align: 'center'},
        {title: '状态', key: 'status', width: 90, align: 'center'},
        {title: '操作', slot: 'action', minWidth: 100, align: 'center', fixed: 'right'}
      ],
      adminTableData: [] // 表格数据
    }
  },
  created() {
    this.getAdminName = localStorage.getItem('peopleName')
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    if (this.$route.query.current !== undefined) {
      this.page = parseInt(this.$route.query.current)
      this.pageSize = parseInt(this.$route.query.size)
      if (this.$route.query.nikeName !== undefined && this.$route.query.nikeName !== '') {
        this.formCustom.nikeName = this.$route.query.nikeName;
      }
      if (this.$route.query.adminCode !== undefined && this.$route.query.adminCode !== '') {
        this.formCustom.adminCode = this.$route.query.adminCode;
      }
      if (this.$route.query.status !== undefined && this.$route.query.status !== '') {
        this.formCustom.status = this.$route.query.status;
      }

      this.setCurrent(this.page)
    } else {
      this.init()
    }
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      roleList({
        organizationType: -1
      }).then((res) => {
        this.roleList = res.data.data
      })
      adminPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.adminTableData = res.data.data.records
      res.data.data.records.forEach((element, index) => {
        if (element.status === -1) {
          this.adminTableData[index].status = '锁定'
        } else if (element.status === 1) {
          this.adminTableData[index].status = '有效'
        }
      })
      res.data.data.records.forEach((element, index) => {
        if (element.gender === 1) {
          this.adminTableData[index].gender = '男'
        } else if (element.gender === 0) {
          this.adminTableData[index].gender = '女'
        }
      })
      this.loading = false
    },
    // 查询
    handleSearch() {
      adminPage({
        current: 1,
        size: this.pageSize,
        nikeName: this.formCustom.nikeName,
        adminCode: this.formCustom.adminCode,
        roleId: this.formCustom.roleId,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 获取下拉框关联角色数据
    changeRole(val) {
      this.formCustom.roleId = val
    },
    // 获取下拉框状态数据
    changeStatus(val) {
      this.formCustom.status = val
    },
    // 新增/编辑跳转
    handleButton(val, id) {
      switch (val) {
        case 'add':
          this.$router.push(
            {
              path: '/authority/admin/adminAdd',
              query: {
                adminId: id,
                current: this.page,
                size: this.pageSize,
                nikeName: this.formCustom.nikeName,
                adminCode: this.formCustom.adminCode,
                status: this.formCustom.status
              }
            }
          )
          break
        case 'edit':
          this.$router.push(
            {
              path: '/authority/admin/adminEdit',
              query: {
                adminId: id,
                current: this.page,
                size: this.pageSize,
                nikeName: this.formCustom.nikeName,
                adminCode: this.formCustom.adminCode,
                status: this.formCustom.status
              }
            }
          )
          break
        case 'authority':
          this.$router.push(
            {
              path: '/authority/admin/adminPassword',
              query: {
                adminId: id,
                current: this.page,
                size: this.pageSize,
                nikeName: this.formCustom.nikeName,
                adminCode: this.formCustom.adminCode,
                status: this.formCustom.status
              }
            }
          )
          break
        default:
          break
      }
    },
    // 改变页码
    setCurrent(val) {
      this.loading = true
      this.page = val
      adminPage({
        current: val,
        size: this.pageSize,
        nikeName: this.formCustom.nikeName,
        adminCode: this.formCustom.adminCode,
        roleId: this.formCustom.roleId,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.pageSize = val
      adminPage({
        current: 1,
        size: this.pageSize,
        nikeName: this.formCustom.nikeName,
        adminCode: this.formCustom.adminCode,
        roleId: this.formCustom.roleId,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 锁定/解锁
    lockButton(val, id) {
      if (val === 'lock') {
        this.lockMsg = '确认锁定？'
        this.lockStatus = -1
      } else if (val === 'unlock') {
        this.lockMsg = '确认解锁？'
        this.lockStatus = 1
      }
      this.$Modal.confirm({
        title: this.lockMsg,
        onOk: () => {
          adminLock({
            adminId: id,
            status: this.lockStatus
          }).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            if (val === 'lock') {
              this.$Message.error('锁定失败')
            } else if (val === 'unlock') {
              this.$Message.error('解锁失败')
            }
          })
        },
        onCancel: () => {
          if (val === 'lock') {
            this.$Message.info('已取消锁定')
          } else if (val === 'unlock') {
            this.$Message.info('已取消解锁')
          }
        }
      })
    },
    // 删除
    remove(id) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          adminDelete(id).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            this.$Message.error('删除失败')
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    }
  }
}
</script>
